import { VARIANT } from "constants/types";

const initState = {
  variant: {}
}


const VariantReducer = (state = initState, action) => {

  const { type, payload, id } = action;

  switch(type) {

    case VARIANT.SET:
      return {
        ...state,
        variant: {
          ...state.variant,
          [id]: payload,
        }
      }

    default:
      return state
  }
}

export default VariantReducer